module.exports = { id: "cart", url: "/build/app/img/symbols.svg#cart", viewBox: "", toString: function() { return this.url; } };